// 首页活动 icon
export let homePageImg =
	"http://www.suguangapi.com:6001/API/File/Get?MCTCode=XSZ&FileName=PCOMS_ActivityIcon.png"
//活动页背景图 img 上
export let activityTopImg =
	"http://www.suguangapi.com:6001/API/File/Get?MCTCode=XSZ&FileName=PCOMS_ActivityBackimg1.png"
//活动页背景图 img 下
export let activityBottomImg =
	"http://www.suguangapi.com:6001/API/File/Get?MCTCode=XSZ&FileName=PCOMS_ActivityBackimg2.png"
// 活动页右侧 img
export let activityByRight =
	"http://www.suguangapi.com:6001/API/File/Get?MCTCode=XSZ&FileName=PCOMS_ActivityRightimg.png"

// 列表配件活动价 img
export let activityByCenter =
	"http://www.suguangapi.com:6001/API/File/Get?MCTCode=XSZ&FileName=PCOMS_ActivityProimg2.png"

// 列表配件活动价 img
export let ActivityRightimg =
	"http://www.suguangapi.com:6001/API/File/Get?MCTCode=XSZ&FileName=PCOMS_ActivityRightimg.png"

// import {TopActiveBanner} from "@/api/activity.js"
// import axios from "axios"
// async function TopActiveBanner1() {
// 	var isshow = false
// 	var arr = []
// 	await TopActiveBanner().then((res) => {
// 		if (res[1]) {
// 			return (isshow = true)
// 		} else return isshow
// 	})
// }
// export {TopActiveBanner1}
